/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useLocalStorage from "react-use-localstorage";
import _ from "lodash";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import pageConfig from "../../data/config.json";
import { AppUtils } from "../../services/AppUtils";
import useGenealogy from "../../services/useGenealogy";
import {
  LOAD_EXTREME_LEFT,
  LOAD_EXTREME_RIGHT,
  LOAD_PREFERRED_LEFT,
  LOAD_PREFERRED_RIGHT,
  isAllowedGenealogyDistributor,
} from "../../services/Constants";
import useMasters from "../../services/useMasters";
import PageLayout from "../../components/PageLayout";
import WishGeneologyTree from "../../components/WishGeneologyTree";
import WishToaster from "../../components/WishToaster";
import WishModal from "../../components/WishModal";
import WishButtonGroup from "../../components/WishButtonGroup";
import RankBadges from "./RankBadges";
import TeamMemberStatus from "./TeamMemberStatus";
import ActivationPV from "./ActivationPV";
import GroupVolume from "./GroupVolume";
import EmptyAnimation from "../../components/EmptyAnimation";
import animation from "../../assets/app-assets/images/lottie/NoDataAvailable.json";
import useDashboard from "../../services/useDashboard";
import GenealogyLoader from "../../components/GenealogyLoader";
import PersonalEnrollmentTree from "./PersonalEnrollmentTree";
import DistCounts from "../analysis/components/DistCounts";

const SwalAlert = withReactContent(Swal);

export default function MyGeneology({ isWebview = false }) {
  const [treeNodes, setTreeNodes] = useState(null);
  const [selectedNode, setSelectedNode] = useState(treeNodes);
  const [filterApplied, applyFilter] = useState(false);
  const [nodeDataToEnrollment, setNodeDataToEnrollment] = useState("");
  const [distributor, setDistributorDetails] = useLocalStorage("distributor", "");
  const [searchParams, setSearchParams] = useSearchParams();
  const { loggedInUser } = useMasters();
  const navigate = useNavigate();

  const studentAccess = JSON.parse(localStorage.getItem("student_access"));

  // console.log('searchParams:', searchParams)// 0

  const {
    distributorGVStats,
    distributorMemberStats,
    distributorStats,
    enrollDistributor,
    genealogyError,
    getPendingEnrolleesFor,
    getTreeData,
    loading,
    genealogyLoading,
    navigateTreeTo,
    navigateTreeToOneLevelUp,
    pendingEnrolleesList,
    placementPositions,
    ranks,
    treeData,
    // fetchDistributorDetails,
  } = useGenealogy(loggedInUser);
  const { getDistributorDetails } = useDashboard(searchParams.get("distributor_id"));

  const [distLoading, setDistLoading] = useState(true);

  const [selectedDistributor, setSelectedDistributor] = useState(-1);
  //  console.log(distributorMemberStats, "distributorMemberStats");
  const placementStructure = {
    distributor_id: "",
    placement_distributor_id: "",
    placement_position_id: 0,
    sponsor_distributor_id: "",
    dist_temp_id: 0,
    password: "",
    confirm_password: "",
  };
  const [selectedPosition, setSelectedPosition] = useState(_.cloneDeep(placementStructure));
  const [selectedNodeParentId, setSelectedNodeParentId] = useState(null);
  const [selectedPositionIndex, setSelectedPositionIndex] = useState(null);
  const [selectedEnrolleeIndex, setSelectedEnrolleeIndex] = useState(null);
  const [selectedEnrollee, setSelectedEnrollee] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isEnrolling, setIsEnrolling] = useState(false);
  const [pageError, setError] = useState(null);

  const data = {
    labels: ["Active Members", "Inactive Members", "Other Members"],
    datasets: [
      {
        data: [
          distributorMemberStats?.Active ?? 0,
          distributorMemberStats?.Inactive ?? 0,
          distributorMemberStats?.Others ?? 0,
        ],
        backgroundColor: ["#87bcf1", "#fbe892", "#f893b0"],
        borderColor: ["#87bcf1", "#fbe892", "#f893b0"],
        borderWidth: 0,
        cutout: "85%",
      },
    ],
  };
  const starData = distributorMemberStats?.star_count;

  useEffect(() => {
    if (isWebview) {
      getDistributorDetails((data) => {
        setDistributorDetails(JSON.stringify(data));
        setDistLoading(false);
      });

      // localStorage.setItem("distributor", JSON.stringify({ distributor_id: parseInt(searchParams.get("distributor_id")) }));
    } else {
      setDistLoading(false);
    }
  }, []);

  useEffect(() => {
    setSelectedDistributor(isWebview ? parseInt(searchParams.get("distributor_id")) : loggedInUser?.distributor_id);
  }, [loggedInUser]);

  useEffect(() => {
    if (!distLoading) {
      if (
        JSON.parse(distributor)?.distributor_rank?.rank_id > 1 ||
        studentAccess?.comment !== 0 ||
        JSON.parse(distributor)?.fast_track_vbo !== 0
      ) {
        if (isAllowedGenealogyDistributor(selectedDistributor)) {
          getTreeData({
            distributor_id: selectedDistributor,
            logged_in_distributor_id: isWebview
              ? parseInt(searchParams.get("logged_in_distributor_id"))
              : loggedInUser.distributor_id,
            depth: 2,
          });
        }
      }
    }
  }, [selectedDistributor, distLoading]);

  useEffect(() => {
    if (treeData) {
      setTreeNodes(treeData);
    }
  }, [treeData]);

  useEffect(() => {
    setError(genealogyError);
  }, [genealogyError]);

  useEffect(() => {
    if (pageError) {
      WishToaster({
        toastMessage: pageError,
      });
    }
  }, [pageError]);

  const showAll = function () {
    applyFilter(false);
    setSelectedNode(data.treeData);
    setTreeNodes(data.treeData);
  };

  const treeTopIcons = function () {
    return (
      <div className="row pl-2 pr-2">
        <button
          className={"d-flex align-items-center text-primary "}
          onClick={() => {
            if (loggedInUser?.distributor_id) {
              setSelectedDistributor(loggedInUser.distributor_id);
            } else {
              setSelectedDistributor(
                isWebview ? parseInt(searchParams.get("logged_in_distributor_id")) : loggedInUser.distributor_id
              );
            }
          }}
        >
          <i className="las la-angle-left"></i>&nbsp;Back to root
        </button>
        &nbsp;&nbsp;
        <button
          className="d-flex align-items-center ml-auto"
          onClick={() => {
            AppUtils.showDialog("dlgSearch");
            //$("#dlgSearch").modal("show");
          }}
        >
          <i className="las la-search"></i>&nbsp;Search
        </button>
        &nbsp;&nbsp;
        {isWebview ? null : (
          <>
            <button
              className="d-flex align-items-center btn btn-primary btn-sm shadow"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="las la-route"></i>&nbsp;Navigation
            </button>
            <div className="dropdown-menu">
              <a
                className="dropdown-item"
                href="#"
                onClick={() => {
                  navigateTreeTo(LOAD_EXTREME_LEFT, selectedDistributor, loggedInUser.distributor_id);
                }}
              >
                To Extreme Left
              </a>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => {
                  navigateTreeTo(LOAD_EXTREME_RIGHT, selectedDistributor, loggedInUser.distributor_id);
                }}
              >
                To Extreme Right
              </a>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => {
                  navigateTreeTo(LOAD_PREFERRED_LEFT, selectedDistributor, loggedInUser.distributor_id);
                }}
              >
                To Preferred Extreme Left
              </a>
              <a
                className="dropdown-item"
                href="#"
                onClick={() => {
                  navigateTreeTo(LOAD_PREFERRED_RIGHT, selectedDistributor, loggedInUser.distributor_id);
                }}
              >
                To Preferred Extreme Right
              </a>
              <a
                className="dropdown-item"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  const rootDistributor = treeNodes.root.distId;

                  if (rootDistributor && parseInt(rootDistributor) !== parseInt(loggedInUser.distributor_id)) {
                    navigateTreeToOneLevelUp(rootDistributor, loggedInUser.distributor_id);
                  } else {
                    WishToaster({
                      toastMessage: "You are already at the top of your organization tree.",
                      toastType: "error",
                    });
                  }
                }}
              >
                To One Level Back
              </a>
            </div>
            &nbsp;&nbsp;
            <Link className="d-flex align-items-center" to="/mygeneologysettings">
              <i className="las la-cog"></i>&nbsp;Settings
            </Link>
          </>
        )}
      </div>
    );
  };

  const getEnrolleeDisplayName = (enrollee) => {
    if (!enrollee) return "";
    return `${enrollee.first_name ?? ""} ${enrollee.second_name ?? ""}`.trim() || `Temp #${enrollee.dist_temp_id}`;
  };

  const getSelectedPositionTitle = () => {
    if (selectedPositionIndex === null || !placementPositions?.[selectedPositionIndex]) return "";
    return placementPositions[selectedPositionIndex].position_title;
  };

  const passwordsMatch =
    !!selectedPosition.password &&
    !!selectedPosition.confirm_password &&
    selectedPosition.password === selectedPosition.confirm_password;

  const canSubmitEnrollment =
    selectedEnrolleeIndex !== null &&
    selectedPositionIndex !== null &&
    selectedPosition.dist_temp_id !== -1 &&
    selectedPosition.placement_position_id !== -1 &&
    passwordsMatch &&
    !isEnrolling;

  const resetEnrollDialogState = () => {
    setSelectedEnrolleeIndex(null);
    setSelectedEnrollee(null);
    setShowPassword(false);
    setShowConfirmPassword(false);
    setIsEnrolling(false);
  };

  const openEnrollDialog = (placementDistributorId, clickedNode) => {
    if (distributor === "") return;

    const distributorFromStorage = JSON.parse(distributor);
    const placementDetails = {
      distributor_id: distributorFromStorage?.distributor_id,
      placement_distributor_id: clickedNode?.parentDistId ?? placementDistributorId,
      placement_position_id: clickedNode?.relationId,
      sponsor_distributor_id: distributorFromStorage?.distributor_id,
      sponsor_distributor_name: distributorFromStorage?.name,
    };
    setNodeDataToEnrollment(placementDetails);

    getPendingEnrolleesFor(loggedInUser.distributor_id, 5, placementDistributorId, (enrolleesList, positionsList) => {
      const positionsArr = Array.from(positionsList?.valid_position_ist ?? []);
      const suggestedPositionId = parseInt(clickedNode?.relationId);
      const suggestedIndex = positionsArr.findIndex((p) => parseInt(p.position_id) === suggestedPositionId);

      setSelectedNodeParentId(placementDistributorId);
      setSelectedPosition({
        ...placementStructure,
        dist_temp_id: -1,
        placement_position_id: suggestedIndex >= 0 ? suggestedPositionId : -1,
        password: "",
        confirm_password: "",
      });
      setSelectedPositionIndex(suggestedIndex >= 0 ? suggestedIndex : null);
      resetEnrollDialogState();
      AppUtils.showDialog("dlgEnroll");
    });
  };

  const enrollUserModal = () => {
    return (
      <WishModal
        id="dlgEnroll"
        title="Enroll New Direct Seller"
        finishTitle={isEnrolling ? "Enrolling..." : "Submit"}
        finishDisabled={!canSubmitEnrollment}
        autoDismissOnFinish={false}
        onFinish={() => {
          if (!canSubmitEnrollment) return;

          const distributorFromLocalStorage = JSON.parse(distributor || "{}");
          if (!distributorFromLocalStorage?.distributor_id) {
            WishToaster({ toastMessage: "Oops! Something went wrong.", toastType: "error" });
            return;
          }

          const payload = {
            ...selectedPosition,
            sponsor_distributor_id: distributorFromLocalStorage.distributor_id,
            distributor_id: distributorFromLocalStorage.distributor_id,
            placement_distributor_id: selectedNodeParentId,
          };

          setIsEnrolling(true);
          enrollDistributor(
            payload,
            selectedDistributor,
            (data) => {
              setIsEnrolling(false);
              AppUtils.hideDialog("dlgEnroll");
              SwalAlert.fire({
                icon: "success",
                title: "Enrollment successful",
                html: data?.name
                  ? `<p>You have successfully enrolled <strong>${data.name}</strong>.</p>
                     <p>Direct Seller ID: <strong>${data.distId}</strong></p>`
                  : "Direct seller enrolled successfully.",
              });
            },
            () => {
              setIsEnrolling(false);
            }
          );
        }}
      >
        {genealogyError ? (
          <h3 className="text-danger">{genealogyError}</h3>
        ) : (
          <>
            <div className="alert alert-secondary py-1 px-2 mb-2">
              <small className="d-block">
                <strong>Placement under:</strong> #{selectedNodeParentId ?? nodeDataToEnrollment?.placement_distributor_id ?? "-"}
              </small>
              <small className="d-block">
                <strong>Position:</strong> {getSelectedPositionTitle() || "Not selected"}
              </small>
              {selectedEnrollee && (
                <small className="d-block">
                  <strong>Enrollee:</strong> {getEnrolleeDisplayName(selectedEnrollee)}
                </small>
              )}
            </div>

            <div className="d-flex justify-content-end mb-1">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  AppUtils.hideDialog("dlgEnroll");
                  navigate("/enrolluser", {
                    state: { placementDetails: nodeDataToEnrollment },
                  });
                }}
              >
                New Enrollment
              </button>
            </div>

            {Array.isArray(pendingEnrolleesList) ? (
              pendingEnrolleesList.length > 0 ? (
                <div>
                  <h5>1. Assign Enrollees</h5>
                  <small>
                    <em>Select a pending enrollee who has completed all stages</em>
                  </small>
                  <div className="list-group mt-1" style={{ maxHeight: "220px", overflow: "auto" }}>
                    {pendingEnrolleesList.map((item, index) => {
                      const displayName = getEnrolleeDisplayName(item);
                      return (
                        <button
                          type="button"
                          key={item.dist_temp_id ?? index}
                          className={
                            "list-group-item list-group-item-action text-left " +
                            (selectedEnrolleeIndex === index ? "active" : "")
                          }
                          onClick={() => {
                            setSelectedEnrolleeIndex(index);
                            setSelectedEnrollee(item);
                            setSelectedPosition((prev) => ({
                              ...prev,
                              dist_temp_id: item.dist_temp_id,
                            }));
                          }}
                        >
                          <span className="d-block">{displayName || `Enrollee #${item.dist_temp_id}`}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <div className="text-center my-2">
                  <p className="mb-1">No pending enrollees found.</p>
                  <small className="text-muted">Start a new enrollment to add someone at this position.</small>
                </div>
              )
            ) : null}

            {pendingEnrolleesList?.length > 0 && placementPositions ? (
              <>
                <h5 className="pt-2">2. Confirm position</h5>
                <WishButtonGroup
                  selectedIndex={selectedPositionIndex}
                  onSelect={(button, index) => {
                    setSelectedPositionIndex(index);
                    setSelectedPosition((prev) => ({
                      ...prev,
                      placement_position_id: placementPositions[index].position_id,
                    }));
                  }}
                  buttons={placementPositions.map((x) => x.position_title)}
                />

                <h5 className="pt-2">3. Set password</h5>
                <div className="form-group row">
                  <label htmlFor="txtPassword2" className="col-md-4 col-form-label">
                    Password
                  </label>
                  <div className="col-md-8">
                    <div className="input-group">
                      <input
                        id="txtPassword2"
                        name="txtPassword2"
                        value={selectedPosition?.password ?? ""}
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        required
                        placeholder="Enter password"
                        onChange={(e) => {
                          setSelectedPosition((prevState) => ({
                            ...prevState,
                            password: e.target.value,
                          }));
                        }}
                      />
                      <div className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowPassword((prev) => !prev)}
                        >
                          <i className={showPassword ? "las la-eye-slash" : "las la-eye"}></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group row mb-0">
                  <label htmlFor="txtConfirmPassword" className="col-md-4 col-form-label">
                    Confirm Password
                  </label>
                  <div className="col-md-8">
                    <div className="input-group">
                      <input
                        id="txtConfirmPassword"
                        name="txtConfirmPassword"
                        value={selectedPosition?.confirm_password ?? ""}
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control"
                        required
                        placeholder="Re-enter password"
                        onChange={(e) => {
                          setSelectedPosition((prevState) => ({
                            ...prevState,
                            confirm_password: e.target.value,
                          }));
                        }}
                      />
                      <div className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowConfirmPassword((prev) => !prev)}
                        >
                          <i className={showConfirmPassword ? "las la-eye-slash" : "las la-eye"}></i>
                        </button>
                      </div>
                    </div>
                    {selectedPosition.confirm_password &&
                      selectedPosition.password !== selectedPosition.confirm_password && (
                        <small className="text-danger">Passwords do not match</small>
                      )}
                  </div>
                </div>
              </>
            ) : null}
          </>
        )}
      </WishModal>
    );
  };
  const body = () => {
    return (
      <>
        <div className="row">
          {JSON.parse(distributor)?.distributor_rank?.rank_id > 1 ||
            studentAccess?.comment !== 0 ||
            JSON.parse(distributor)?.fast_track_vbo !== 0 ? (
            <>
              <div className="col-12">
                {treeNodes && !genealogyLoading ? (
                  <WishGeneologyTree
                    loading={loading}
                    header={treeTopIcons()}
                    reverse={true}
                    tree={treeNodes.root}
                    showBackButton={filterApplied}
                    onNodeSelected={(distributorId, isActionNode, clickedNode) => {
                      if (!isActionNode) {
                        if (isAllowedGenealogyDistributor(distributorId)) {
                          setSelectedDistributor(distributorId);
                        } else {
                          WishToaster({
                            toastMessage: "Invalid direct seller Id",
                            toastType: "error",
                          });
                        }
                      } else {
                        openEnrollDialog(distributorId, clickedNode);
                      }
                    }}
                    onResetRequested={() => {
                      showAll();
                    }}
                    onSearchClicked={(searchString) => {
                      if (isAllowedGenealogyDistributor(searchString)) {
                        setSelectedDistributor(parseInt(searchString, 10));
                      } else {
                        WishToaster({
                          toastMessage: "Invalid direct seller Id",
                          toastType: "error",
                        });
                      }
                    }}
                  />
                ) : (
                  <GenealogyLoader />
                )}
              </div>
              <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                <GroupVolume distributorGVStats={distributorGVStats} selectedDistributor={selectedDistributor} />
              </div>
              <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                <div className="row">
                  <ActivationPV distributorStats={distributorStats} />
                  <div className="col-12">
                    <TeamMemberStatus
                      data={data}
                      distributorMemberStats={distributorMemberStats}
                      className={"rounded-1 border-light"}
                      width={"200px"}
                      height={"200px"}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12">
                <DistCounts downlineCount={starData} />
              </div>
              <div className="col-12">
                <PersonalEnrollmentTree />
              </div>
              <RankBadges ranks={ranks} />
            </>
          ) : (
            <div className="col-12">
              <EmptyAnimation
                message={"No data to display. Please come back when you're a star Direct Seller or above"}
                lottieAnimation={animation}
              />
            </div>
          )}
        </div>
        {enrollUserModal()}
      </>
    );
  };
  return isWebview ? (
    <>
      {!distLoading ? (
        JSON.parse(distributor)?.distributor_rank?.rank_id > 1 ||
          studentAccess?.comment !== 0 ||
          JSON.parse(distributor)?.fast_track_vbo !== 0 ? (
          <div className="row">
            <div className="col-12">
              {treeNodes ? (
                <WishGeneologyTree
                  loading={loading}
                  header={treeTopIcons()}
                  reverse={true}
                  tree={treeNodes.root}
                  showBackButton={filterApplied}
                  onNodeSelected={(distributorId, isActionNode, clickedNode) => {
                    if (!isActionNode) {
                      if (isAllowedGenealogyDistributor(distributorId)) {
                        setSelectedDistributor(distributorId);
                      } else {
                        WishToaster({
                          toastMessage: "Invalid direct seller Id",
                          toastType: "error",
                        });
                      }
                    } else {
                      openEnrollDialog(distributorId, clickedNode);
                    }
                  }}
                  onResetRequested={() => {
                    showAll();
                  }}
                  onSearchClicked={(searchString) => {
                    if (isAllowedGenealogyDistributor(searchString)) {
                      setSelectedDistributor(parseInt(searchString, 10));
                    } else {
                      WishToaster({
                        toastMessage: "Invalid direct seller Id",
                        toastType: "error",
                      });
                    }
                  }}
                />
              ) : (
                <GenealogyLoader />
              )}
            </div>
          </div>
        ) : (
          <div className="col-12">
            <EmptyAnimation
              message={"No data to display. Please come back when you're a star Direct Seller or above"}
              lottieAnimation={animation}
            />
          </div>
        )
      ) : null}
      {enrollUserModal()}
    </>
  ) : (
    <PageLayout {...pageConfig.mygenealogy}>{body()}</PageLayout>
  );
}
